module.exports = __webpack_public_path__ + "static/media/dashboard.89a73eb8.png";